import {
  Box,
  StackLayout,
  UtilityText,
  Divider,
} from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { useIsBelowTablet } from "hooks/use-is-below-tablet.hook";
import type { ProfileFieldValues } from "types/profile-field-content.types";

export interface ProfileFieldContentProps {
  profileFieldValues: ProfileFieldValues;
}

export const ProfileFieldContent = ({
  profileFieldValues,
}: ProfileFieldContentProps) => {
  const isBelowTablet = useIsBelowTablet();
  const { formatMessage } = useIntl();

  return (
    <>
      {profileFieldValues.map(({ label, value, isLocked }, index) => (
        <Box key={label}>
          <StackLayout
            orientation={isBelowTablet ? "vertical" : "horizontal"}
            horizontalAlignment="spaceBetween"
          >
            <UtilityText
              css={{
                typography: "$label",
                marginBlockEnd: isBelowTablet ? "$threeQuarters" : "none",
                marginInlineEnd: "$one",
                color: isLocked
                  ? "$onSurfaceTextSubdued"
                  : "$onSurfaceTextPrimary",
              }}
            >
              {label}
            </UtilityText>
            <UtilityText
              emphasis={value ? "emphasized" : "subtle"}
              size="sm"
              css={{
                textAlign: isBelowTablet ? "start" : "end",
                color: isLocked ? "$onSurfaceTextSubdued" : undefined,
                whiteSpace: "pre-line",
              }}
            >
              {/* // TODO: Verify what the expected behavior is when value is not specified */}
              {value || formatMessage({ id: "STR_NOT_SPECIFIED" })}
            </UtilityText>
          </StackLayout>
          {index + 1 !== profileFieldValues.length && (
            <Divider css={{ marginBlock: 14 }} />
          )}
        </Box>
      ))}
    </>
  );
};
